<template>
  <div id="admin-paxs-list" class="container-fluid item-list pb-64 admin-paxs-wide">
    <v-list-header
      :title="this.$t('general.adminMenu.paxs')"
      icon="group"
      @open-filters-offcanvas="openOffCanvas('the-case-pax-detail-offcanvas')"
      @emit-close-off-canvas="closeOffCanvas"
      @reload-users="loadPaxs"
    >
      <template #input-search>
        <v-input-text-search
          id="user-search"
          v-model="mix"
          :placeholder="this.$t('general.shared.search')"
          autocomplete="off"
          class="w-100 me-24"
          input-class="h-auto py-4"
          input-group-text-class="py-4 px-16"
          type="text"
          @update:modelValue="
            mix = $event;
            search();
          "
        />
      </template>
    </v-list-header>

    <div class="items-content">
      <div class="list-table-shell mt-12">
        <div class="table-responsive d-none d-md-flex table-for-admin-paxs">
        <v-table>
          <v-table-header>
            <tr class="align-middle">
              <th>
                {{ $t("general.shared.name") }}
                <v-button
                  :class="{ 'sort-active': order.key === 'name' }"
                  class="btn-xs btn-icon btn btn-order"
                  @click="toggleOrder('name')"
                >
                  <v-icon
                    :class="{ 'sort-icon-transition': order.key === 'name' && order.order === 'DESC' }"
                    icon="chevron-down"
                    size="xs"
                  />
                </v-button>
              </th>

              <th>
                {{ $t("general.shared.email") }}
              </th>

              <th class="fit" />
            </tr>
          </v-table-header>

          <v-table-body class="fw-medium">
            <tr v-if="!loaded">
              <td class="position-relative border-0 py-96" colspan="2222">
                <v-loader />
              </td>
            </tr>

            <template v-else-if="!!paxs && paxs.length > 0">
              <tr class="align-middle" v-for="pax in paxs" :key="pax.id">
                <td class="d-flex align-items-center">
                  <div class="image-container rounded-sm bg-primary me-12">
                    {{ !!pax.name ? pax.name.charAt(0) : "" }}
                  </div>

                  <span class="py-4">
                    {{ pax.name }}
                  </span>
                </td>

                <td>{{ pax.email }}</td>

                <td class="fit text-end align-middle admin-paxs-actions-cell">
                  <div class="d-flex align-items-center justify-content-end flex-nowrap gap-8">
                    <v-button
                      class="btn-view admin-row-action-btn"
                      size="xs"
                      variant="icon"
                      @click="
                        isPaxDetailshow = true;
                        selectedPax = pax;
                      "
                    >
                      <v-icon icon="eye" />
                    </v-button>
                    <v-button class="btn-view admin-row-action-btn" size="xs" variant="icon" @click="openEditPaxModal(pax)">
                      <v-icon icon="pencil" />
                    </v-button>
                  </div>
                </td>
              </tr>
            </template>

            <template v-else>
              <tr>
                <td class="rounded-xs py-16" colspan="2222">
                  {{ $t("admin.user.noUsers") }}
                </td>
              </tr>
            </template>
          </v-table-body>
        </v-table>
        </div>
      </div>

      <div class="item-cards d-block d-md-none">
        <div v-if="!loaded" class="position-relative py-96">
          <v-loader />
        </div>

        <template v-else-if="!!paxs && paxs.length > 0">
          <div
            v-for="pax in paxs"
            :key="pax.id"
            class="item-card border d-flex justify-content-between align-items-center rounded-xs p-8 mb-12 text-sm"
          >
            <div class="d-flex align-items-center">
              <div class="image-container rounded-sm bg-primary me-12">
                {{ !!pax.name ? pax.name.charAt(0) : "" }}
              </div>

              <div>
                <div class="fw-medium">{{ pax.name }}</div>
                <div class="fw-light text-email text-xs">{{ pax.email }}</div>
              </div>
            </div>

            <div class="d-flex justify-content-end align-items-center flex-nowrap gap-8">
              <v-button
                class="btn-view admin-row-action-btn"
                size="xs"
                variant="icon"
                @click="
                  isPaxDetailshow = true;
                  selectedPax = pax;
                "
              >
                <v-icon icon="eye" />
              </v-button>
              <v-button class="btn-view admin-row-action-btn" size="xs" variant="icon" @click="openEditPaxModal(pax)">
                <v-icon icon="pencil" />
              </v-button>
            </div>
          </div>
        </template>

        <div v-else>
          {{ $t("admin.user.noUsers") }}
        </div>
      </div>

      <v-pagination
        v-if="!!paxs && paxs.length > 0"
        :meta="pagination.meta"
        :pagination-links="pagination.links"
        class="mt-4"
        @page-changed="
          changePage($event);
          handlePageChangedEvent($event);
        "
        @per-page-changed="
          perPage = $event;
          doSearch();
        "
      />
    </div>

    <the-case-pax-detail-offcanvas
      v-if="offCanvasToShow === 'the-case-pax-detail-offcanvas'"
      v-model:case-id="caseId"
      :agency="agency.slug"
      @closed="closeOffCanvas"
      @selected="doSearch"
    />

    <v-modal
      v-if="isPaxDetailshow"
      @closed="
        selectedPax = null;
        isPaxDetailshow = false;
      "
    >
      <modal-header class="header-container">
        <h5>{{ $t("general.paxDetails") }}</h5>
        <button
          type="button"
          @click="
            selectedPax = null;
            isPaxDetailshow = false;
          "
          aria-label="Close"
          class="btn-icon btn fw-medium p-4"
          data-bs-dismiss="modal"
          title="Close"
        >
          <span class="icon-close icon"></span>
        </button>
      </modal-header>
      <modal-body class="modalMessage">
        <table class="modalTable">
          <tbody>
            <tr>
              <th>{{ $t("general.shared.addressStreet") }}</th>
              <td>{{ selectedPax?.address_street || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.addressCity") }}</th>
              <td>{{ selectedPax?.address_city || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.addressPostalCode") }}</th>
              <td>{{ selectedPax?.address_cp || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.addressState") }}</th>
              <td>{{ selectedPax?.address_state || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.addressCountry") }}</th>
              <td>{{ selectedPax?.address_country || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.birthDate") }}</th>
              <td>{{ selectedPax?.birth_date || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.language") }}</th>
              <td>{{ selectedPax?.language || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.allergies") }}</th>
              <td>{{ selectedPax?.allergies || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.diet") }}</th>
              <td>{{ selectedPax?.diet || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.height") }}</th>
              <td>{{ selectedPax?.height || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.weight") }}</th>
              <td>{{ selectedPax?.weight || "-" }}</td>
            </tr>
            <tr>
              <th>{{ $t("general.shared.holdedId") }}</th>
              <td>{{ selectedPax?.holded_id || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </modal-body>
    </v-modal>
    <the-pax-info-edit-modal
      v-if="showPaxModal"
      :agency="agency.slug"
      :case-id="Number(caseId)"
      :pax="selectedPax"
      @reloadPax="loadPaxs"
      @closed="showPaxModal = false; selectedPax = null;"
    />
  </div>
</template>

<script lang="ts" name="TheAdminPaxs">
import { defineComponent } from "vue";
import { VInputTextSearch } from "@uniqoders/form";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import VTable from "@/components/vendor/basic/table/VTable.vue";
import VTableHeader from "@/components/vendor/basic/table/VTableHeader.vue";
import VTableBody from "@/components/vendor/basic/table/VTableBody.vue";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import api from "@/api";
import withTimeout from "@/helpers/timeOut";
import useOffCanvasUtils from "@/helpers/OffCanvasUtils";
import TheCasePaxDetailOffcanvas from "@/components/case/TheCasePaxDetailOffcanvas.vue";
import VListHeader from "@/components/shared/VListHeader.vue";
import VPagination from "@/components/vendor/basic/table/VPagination.vue";
import usePagination from "@/helpers/pagination";
import { findConceptByKey } from "@/helpers/ConceptHelper";
import useCapabilities from "@/helpers/capabilities";
import { mapState } from "pinia";
import { useAuthStore } from "@/stores/auth";
import VModal from "@/components/vendor/basic/modal/VModal.vue";
import ThePaxInfoEditModal from "@/components/pax/ThePaxInfoEditModal.vue";

export default defineComponent({
  name: "TheAdminPaxs",
  components: {
    VPagination,
    VListHeader,
    VLoader,
    VTableBody,
    VTableHeader,
    VTable,
    VButton,
    VInputTextSearch,
    VIcon,
    VModal,
    TheCasePaxDetailOffcanvas,
    ThePaxInfoEditModal
  },
  setup() {
    return {
      ...useCapabilities(),
      ...useOffCanvasUtils(),
      ...usePagination(),
    };
  },
  data() {
    return {
      paxs: [] as any[],
      currentPax: null as null | any,
      status: "active" as string,
      mix: "" as string,
      caseId: null as number | null,
      filters: [
        {
          variable: "status",
          key: "status",
          labelAux: "general.shared.filterStatus",
          conceptName: "app.states",
          multiple: false,
          isConcept: true,
        }
      ] as Record<string, string | boolean>[],
      order: {
        key: "" as string,
        order: "" as string,
      } as Record<string, any>,
      perPage: 15 as number,
      page: 1 as number,
      timers: {
        name: null as any,
      },
      loaded: false as boolean,
      filterOptions: [] as Record<string, any>[],
      isPaxDetailshow: false as boolean,
      selectedPax: null as null | any,
      showPaxModal: false as boolean,
    };
  },
  computed: {
    ...mapState(useAuthStore, ["agency"]),
  },
  async created() {
    const { name, case_id } = this.$route.query;
    if (name) {
      this.mix = String(name);
    }

    if (case_id) {
      this.caseId = Number(case_id);
    }
    await this.doSearch();
  },
  methods: {
    search() {
      clearTimeout(this.timers.name);

      this.timers.name = withTimeout(
        async () => {
          await this.doSearch();
        },
        this.timers.name,
        1000
      );
    },
    async doSearch() {
      this.page = 1;
      this.$router.replace({
        query: {
          ...this.$route.query,
          name: this.mix || undefined,
          status: this.status || undefined,
          case_id: this.caseId || undefined,
          page: this.page,
        },
      });
      await this.loadPaxs();
    },
    async loadPaxs(page?: number) {
      try {
        this.loaded = false;

        const query: any = {
          perPage: this.perPage,
          page: !!page ? page : this.page,
        };

        if (this.mix && this.mix.trim() !== "") {
          query.name = this.mix.trim();
        }

        if (this.caseId) {
          query.case_id = this.caseId;
        }

        const response = await api.pax.paxAll(this.agency.slug, query);

        this.setResponseV2(response);

        this.paxs = response?.content?.data;
      } catch (e: any) {
        console.error(e);

        this.$toast.error(e.response.data.message);
      } finally {
        this.loaded = true;
      }
    },
    async handlePageChangedEvent(page: number) {
      await this.loadPaxs(page);
    },
    toggleOrder(field: string) {
      const { order } = this.order;

      if (!order) {
        this.order.order = "ASC";
      } else {
        this.order.order = order === "ASC" ? "DESC" : "ASC";
      }

      this.order.key = field;

      this.search();
    },
    setFilters() {
      this.filterOptions = this.filters.flatMap((filter: Record<string, any>) => {
        const { key, multiple, isConcept, labelAux, conceptName, variable } = filter;

        const options = multiple ? this[variable] : [this[variable]];

        return options.map((option: any) => {
          const value = isConcept ? findConceptByKey(`${conceptName}`, option) : option;
          const label = this.$t(`${labelAux}`, { value: !!conceptName ? value.name : value });
          return { key, value: !!conceptName ? value.key : value, label };
        });
      });
    },
    removeFilter(filter: Record<string, string>) {
      this.filters.forEach((filterAux: Record<string, string | boolean>) => {
        if (filterAux.key === filter.key) {
          if (!filterAux.multiple) {
            this[filterAux.variable] = "";
          } else {
            this[filterAux.variable] = this[filterAux.variable].filter((option: string) => option !== filter.value);
          }
        }
      });

      if (filter.key === "status") {
        this.status = "active";
      }

      this.doSearch();
    },
    openEditPaxModal(pax: any)  {
  this.selectedPax = pax;
  this.showPaxModal = true;
}
  },
});
</script>

<style scoped>
.modalMessage {
  padding: 15px;
}

.modalTable {
  width: 100%;
  margin-bottom: 12px;
}

.modalTable tr {
  border: 1px solid #ddd;
  padding: 12px;
}

.modalTable td {
  border: 1px solid #ddd;
  padding: 12px;
}

.modalTable th {
  padding: 12px;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 15px;
}
</style>

<style scoped lang="scss">
.admin-paxs-wide {
  max-width: 1550px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

@media (min-width: 1400px) {
  .admin-paxs-wide {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
}

.image-container {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
  border-radius: 6px !important;
  background-color: #fd0c6f !important;
}

.admin-row-action-btn {
  border-radius: 6px !important;
}

.admin-paxs-actions-cell {
  white-space: nowrap;
}

:deep(.btn:not(.rounded-circle)) {
  border-radius: 6px !important;
}

:deep(.btn-primary) {
  background-color: #fd0c6f !important;
  border-color: #fd0c6f !important;
  color: #fff !important;
}

:deep(.btn-primary:hover) {
  background-color: #dc095f !important;
  border-color: #dc095f !important;
}

:deep(.btn-order) {
  font-size: 12px !important;
  font-weight: 700 !important;
}

:deep(.input-group-text),
:deep(.form-control),
:deep(.form-select) {
  border-radius: 6px !important;
}

:deep(.input-group-text) {
  min-height: 36px;
}

:deep(.form-control),
:deep(.form-select) {
  min-height: 36px;
  font-size: 13px;
}
</style>
